import "./styles.scss";
import { handleKeyboardEvent } from "../../../utils/Helper";

const index = ({
  title,
  buttonClass = "",
  onClickHandler,
  icon,
  iconClassName = "",
  isDisabled = false,
}) => {
  // If onClickHandler is provided, use anchor; otherwise, fallback to div for JS logic
  if (typeof onClickHandler === "string") {
    return (
      <a
        href={onClickHandler}
        target="_blank"
        rel="noopener noreferrer"
        className={`common-button ${buttonClass}`}
      >
        <span className="align-items-center d-flex justify-between w-100 h-100">
          <span className="d-flex align-items-center gap-2">
            {title}
            {icon && (
              <img
                src={icon}
                alt="button-icon"
                className={`button-icon${
                  iconClassName ? ` ${iconClassName}` : ""
                }`}
              />
            )}
          </span>
        </span>
      </a>
    );
  }
  return (
    <button
      type="button"
      className={`common-button ${buttonClass}`}
      onClick={onClickHandler}
      onKeyDown={(e) => handleKeyboardEvent(e, onClickHandler)}
      disabled={isDisabled}
    >
      <span className="align-items-center d-flex justify-between w-100 h-100">
        <span className="d-flex align-items-center gap-2">
          {title}
          {icon && (
            <img
              src={icon}
              alt="button-icon"
              className={`button-icon${
                iconClassName ? ` ${iconClassName}` : ""
              }`}
            />
          )}
        </span>
      </span>
    </button>
  );
};

export default index;
